import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
} from "@mui/material";
import { APP_COLOR } from "../../theme";

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 300 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 10,
    backgroundColor: APP_COLOR,
  },
}));

export const StorageContainer = styled(Box)(({ theme }) => ({
  width: "30%",
  marginLeft: "auto",
  marginRight: "1",
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%",
    marginLeft: "2px",
    marginRight: "2px",
  },
}));
